export interface ConsentUiTexts {
  readonly bannerTitle: string;
  readonly bannerBody: string;
  readonly acceptAll: string;
  readonly rejectAll: string;
  readonly settings: string;
  readonly dialogTitle: string;
  readonly dialogBody: string;
  readonly dialogAcceptAll: string;
  readonly dialogRejectAll: string;
  readonly save: string;
  readonly close: string;
  readonly alwaysActive: string;
  readonly policyLink: string;
  readonly withdrawalNote: string;
  readonly loading: string;
  readonly unavailable: string;
  readonly retry: string;
  readonly saveError: string;
  readonly noticeBody: string;
  readonly details: string;
  readonly confirm: string;
  readonly emptyCategory: string;
  readonly services: string;
  readonly retention: string;
  readonly vendorPolicy: string;
  readonly service: string;
  readonly provider: string;
  readonly storageName: string;
  readonly storageKind: string;
  readonly purpose: string;
  readonly duration: string;
  readonly kindCookie: string;
  readonly kindLocalStorage: string;
  readonly kindSessionStorage: string;
  readonly noServices: string;
}

export type ConsentUiLanguage = 'tr' | 'en';

// Brand-neutral defaults. A site names itself through `logo` and `texts`, never here.
export const DEFAULT_TEXTS: Readonly<Record<ConsentUiLanguage, ConsentUiTexts>> =
  {
    tr: {
      bannerTitle: 'Çerez tercihleriniz',
      bannerBody:
        'Bu site, çalışması için gereken çerezleri kullanır. İsteğe bağlı çerezler ve benzeri teknolojiler siz izin verene kadar çalışmaz.',
      acceptAll: 'Kabul et',
      rejectAll: 'Reddet',
      settings: 'Ayarlar',
      dialogTitle: 'Çerez tercihleri',
      dialogBody:
        'Her kategoriyi ayrı ayrı açıp kapatabilirsiniz. Kararınızı istediğiniz zaman bu pencereden değiştirebilirsiniz.',
      dialogAcceptAll: 'Tümünü kabul et',
      dialogRejectAll: 'Tümünü reddet',
      save: 'Seçimimi kaydet',
      close: 'Kapat',
      alwaysActive: 'Her zaman açık',
      policyLink: 'Çerez Politikası',
      withdrawalNote:
        'Bir izni geri çektiğinizde yeni yüklemeler durur; daha önce yüklenmiş içerik sayfa yenilenene kadar çalışmaya devam edebilir.',
      loading: 'Tercihler yükleniyor…',
      unavailable:
        'Tercih sistemine şu an ulaşılamıyor. İsteğe bağlı çerezler kapalı kalmaya devam ediyor.',
      retry: 'Tekrar dene',
      saveError: 'Tercihiniz kaydedilemedi. Lütfen tekrar deneyin.',
      noticeBody:
        'Bu site yalnızca çalışması için gereken çerezleri kullanır. Şu anda isteğe bağlı analiz, tercih ya da pazarlama teknolojisi kullanılmıyor.',
      details: 'Ayrıntılar',
      confirm: 'Tamam',
      emptyCategory:
        'Şu anda bu kategoride bir hizmet kullanılmıyor. Eklenirse burada listelenir ve yalnızca izninizle çalışır.',
      services: 'Hizmetler',
      retention: 'Saklama süresi',
      vendorPolicy: 'Gizlilik politikası',
      service: 'Hizmet',
      provider: 'Sağlayıcı',
      storageName: 'Ad',
      storageKind: 'Tür',
      purpose: 'Amaç',
      duration: 'Süre',
      kindCookie: 'Çerez',
      kindLocalStorage: 'Yerel depolama',
      kindSessionStorage: 'Oturum depolaması',
      noServices: 'Bu sitede listelenmiş bir hizmet bulunmuyor.',
    },
    en: {
      bannerTitle: 'Your cookie choices',
      bannerBody:
        'This site uses the cookies it needs to work. Optional cookies and similar technologies stay off until you allow them.',
      acceptAll: 'Accept',
      rejectAll: 'Reject',
      settings: 'Settings',
      dialogTitle: 'Cookie preferences',
      dialogBody:
        'You can switch each category on or off. You can change your decision from this window at any time.',
      dialogAcceptAll: 'Accept all',
      dialogRejectAll: 'Reject all',
      save: 'Save my choices',
      close: 'Close',
      alwaysActive: 'Always on',
      policyLink: 'Cookie Policy',
      withdrawalNote:
        'When you withdraw a permission, new loads stop; content that already loaded may keep running until the page is reloaded.',
      loading: 'Loading preferences…',
      unavailable:
        'The preference service cannot be reached right now. Optional cookies remain off.',
      retry: 'Try again',
      saveError: 'Your choice could not be saved. Please try again.',
      noticeBody:
        'This site only uses the cookies it needs to work. No optional analytics, preference or marketing technology is in use.',
      details: 'Details',
      confirm: 'OK',
      emptyCategory:
        'No service in this category is in use. If one is added, it will be listed here and run only with your permission.',
      services: 'Services',
      retention: 'Retention',
      vendorPolicy: 'Privacy policy',
      service: 'Service',
      provider: 'Provider',
      storageName: 'Name',
      storageKind: 'Type',
      purpose: 'Purpose',
      duration: 'Duration',
      kindCookie: 'Cookie',
      kindLocalStorage: 'Local storage',
      kindSessionStorage: 'Session storage',
      noServices: 'No services are listed for this site.',
    },
  };
